import { defineMessages } from 'react-intl'

export const accountMenuMessages = defineMessages({
  aboutCompany: {
    id: 'accountMenu.aboutCompany',
    description: 'Text on menu link to view about company page',
    defaultMessage: 'About Company',
  },
  accountProfile: {
    id: 'accountMenu.accountProfile',
    description: "Text on menu link to view user's account profile",
    defaultMessage: 'Profile',
  },
  paymentMethods: {
    id: 'accountMenu.paymentMethods',
    description: 'Text on menu link to view payment methods',
    defaultMessage: 'Payment Methods',
  },
  billingHistory: {
    id: 'accountMenu.billingHistory',
    description: 'Text on menu link to view billing history',
    defaultMessage: 'Billing History',
  },
  logOut: {
    id: 'accountMenu.logOut',
    description: 'Text on menu link to log out',
    defaultMessage: 'Sign Out',
  },
  company: {
    id: 'accountMenu.company',
    description: 'Text for "Company" sub-menu-title',
    defaultMessage: 'Company',
  },
})
